import styled, { css, keyframes } from 'styled-components'
import LogoIcon from 'assets/icons/logo-chair.svg'

const waveAnimation = keyframes`
  from { left: -400px; }
  to { left: 400px; }
`

const FallbackLogoIcon = styled.div`
  margin-left: 500px;
  margin: 50px;
  display: block;
  mask-size: cover;
  mask-image: url(${LogoIcon});
  background-color: var(--color-gray-300);
  position: relative;
  width: 288px;
  height: 284px;

  ${({ theme }) => css`
    ${theme.breakpoints.down('sm')} {
      width: 192px;
      height: 189px;
    }
  `}

  ::before {
    content: '';
    display: block;
    top: -50px;
    width: 50px;
    height: calc(100% + 100px);
    position: relative;
    filter: blur(50px);
    transform: rotate(45deg);
    animation: ${waveAnimation} 1000ms ease infinite;
    background-color: ${({ theme }) => theme.palette.common.black};
  }

  will-change: filter;
`

export { FallbackLogoIcon }
